import store from '@/store';

import {Room} from "@/core/api/room.api";
import {RoomInfo} from "@/core/api/room.info.api";
import {RoomCall} from "@/core/api/room.call.api";
import {RoomCallMixer} from "@/core/api/room.call.mixer.api";
import {RoomGoalSchedule} from "@/core/api/room.goalSchedule.api";

const data = {};

const pageBeforeUnloadEvent = e => {
  console.log('# page unload :', JSON.stringify(e, null, '  '), e);
  e.returnValue = '';
  setRoomSilentReload();
}
const pageUnloadedEvent = e => {
  if(data._exec_unload){
    return;
  }
  data._exec_unload = true;
  console.log('# page unloaded :', e.type, JSON.stringify(e, null, '  '), e);
  Room.reqLeave('going_away').catch(e => console.error(e));
}

const setRoomSilentReload = () => {
  const deviceSettings = store.getters['room/deviceSettings'];
  const { micStatus, cameraStatus, speakerStatus, userId, roomId } = Room.User.getMe();
  Object.assign(deviceSettings, { micStatus, cameraStatus, speakerStatus });

  const RoomSilentReload = { regDate: new Date(),  deviceSettings };

  if(Room.isCamStudy()) {
    // 새로고침 캠스터디 정보 set은 roomActions, 새로고침 후 캠스터디 정보 get은 camstudyActions
    const stopwatch = store.getters['camstudy/getUserStopwatch'](userId)
    const CamStudySilentReload = {roomId, stopwatchState: stopwatch?.state};
    sessionStorage.setItem('CAMSTUDY_SILENT_RELOAD', JSON.stringify(CamStudySilentReload));
  }
  sessionStorage.setItem('ROOM_SILENT_RELOAD', JSON.stringify(RoomSilentReload));
}

export default {
  getRoom: async ({dispatch, commit, getters, rootGetters }, { roomId, roomUrlId }) => {
    return await Room.getRoom({ roomId, roomUrlId });
  },
  checkRoom: async ({dispatch, commit, getters, rootGetters }, { roomId, roomUrlId }) => {
    const res =  await Room.checkRoom({ roomId, roomUrlId });
    commit('SET_ROOM_LEVEL', {roomLevel: res?.data?.roomLevel});
    return res;
  },
  createRoom: async ({dispatch, commit, getters, rootGetters }, room) => {
    return await Room.createRoom(room);
  },
  setRoomInfo: async ({dispatch, commit, getters, rootGetters }, roomUrlId) => {
    const data = await RoomInfo.setRoomInfo(roomUrlId);
    commit('ROOM_INFO_INIT', data)
  },
  saveDeviceSettings: ({ dispatch, commit, getters, rootGetters }, {deviceSettings}) => {
    commit('SET_DEVICE_SETTINGS', deviceSettings);
    RoomCall.Stream.setLocalDeviceSetting(deviceSettings);
  },

  enter: async ({ dispatch, commit, getters, rootGetters }, {enterParams, deviceSettings}) => {
    await Room.enter({
      enterParams,
      deviceSettings
    });
    dispatch('setBeforeUnloadEvent');
  },
  leave: async () => {
    // Room.leave().catch(e => console.error(e));
  },
  reqLeave: async ({ dispatch, commit, getters, rootGetters }, reason) => {
    dispatch('unsetBeforeUnloadEvent');
    Room.reqLeave(reason || 'going_away').catch(e => console.error(e));
  },
  setBeforeUnloadEvent: () => {
    window.addEventListener('beforeunload', pageBeforeUnloadEvent);
    window.addEventListener('pagehide', pageUnloadedEvent);
    window.addEventListener('unload', pageUnloadedEvent);

    const wakeLock = async () => {
      if(document.visibilityState !== 'visible'){
        return;
      }
      if(data._wakeLock && data._wakeLock.released){
        return;
      }
      try{
        data._wakeLock = await navigator.wakeLock.request('screen')
        data._wakeLock.addEventListener('release', e => {
          console.log('# wakeLock - released :', data._wakeLock)
          data._wakeLock = null;
          wakeLock();
        });
        window.ww = data._wakeLock
        console.log('# wakeLock - set :', data._wakeLock)
      } catch (e) {
        console.error(e);
      }
    }
    document.addEventListener("visibilitychange", async e => {
      await wakeLock();
    })
    wakeLock().catch(e => console.error(e));
  },
  unsetBeforeUnloadEvent: () => {
    window.removeEventListener('beforeunload', pageBeforeUnloadEvent);
    try{
      data._wakeLock && data._wakeLock.release();
    }catch(e){console.error(e)}
  },
  checkSilentReload: async ({ dispatch, commit, getters, rootGetters }) => {
    const pageReloaded = await new Promise((resolve, reject) => {
      try{
        let timer = setTimeout(() => {
          console.log('check reload timeout');
          resolve();
        }, 500);
        const observer = new PerformanceObserver((list) => {
          // list.getEntries().forEach((entry) => {
          //   console.log(entry.type, entry);
          // });
          clearTimeout(timer);
          observer.disconnect();
          resolve(list.getEntries()[0]?.type === 'reload');
        });
        observer.observe({ type: "navigation", buffered: true });
      }catch(e){
        console.warn(e);
        resolve();
      }
    });
    if(!pageReloaded){
      return null;
    }

    let RoomSilentReload = sessionStorage.getItem('ROOM_SILENT_RELOAD');
    sessionStorage.removeItem('ROOM_SILENT_RELOAD');

    if(RoomSilentReload){
      try{
        RoomSilentReload = JSON.parse(RoomSilentReload);
      }catch(e){
        console.error(e);
        return null;
      }
    }

    if(!RoomSilentReload || !RoomSilentReload.regDate){
      return null;
    }

    if(new Date() - RoomSilentReload.regDate > 3000){
      return null;
    }

    // if(RoomSilentReload.deviceSettings){
    //   dispatch('saveDeviceSettings', {
    //     deviceSettings: RoomSilentReload.deviceSettings
    //   })
    // }

    return RoomSilentReload;
  },
  reloadRoom: ({ dispatch, commit, getters, rootGetters }, {silent=false}) => {
    dispatch('unsetBeforeUnloadEvent');

    if(silent === true){
      // let url = `${location.protocol}//${location.host}${location.pathname}`
      //   + `${location.search?'?'+location.search:''}`
      //   + `${location.hash?'#'+location.hash:''}`;
      const deviceSettings = getters.deviceSettings;

      const {micStatus, cameraStatus, speakerStatus} = Room.User.getMe();
      Object.assign(deviceSettings, {
        micStatus, cameraStatus, speakerStatus
      });

      const RoomSilentReload = {
        regDate: new Date(),
        deviceSettings
      };
      sessionStorage.setItem('ROOM_SILENT_RELOAD', JSON.stringify(RoomSilentReload));
    }

    location.reload();
  },

  // 참여자 정렬 선택
  selectSort({ commit }, e) {
    commit('SELECT_SORT', e)
    commit('user/SORT_USERS', e, { root: true })
  },

  // 참여자 권한 선택
  selectAuth({ commit }) {
    commit('TOGGLE_AUTH_MODAL')
  },

  changeRoomMode: async ({ dispatch, commit, getters, rootGetters }, { roomMode }) => {
    if(getters.isRoomMode('screenShare') && roomMode !== 'screenShare'){
      dispatch('stopScreenShare', {})
    }

    await Room.changeRoomMode(roomMode);
  },

  changeMixingLayoutType: async ({ dispatch, commit, getters, rootGetters }, {
    layoutType
  }) => {
    await RoomCall.Mixer.changeMixingLayoutType({ layoutType });
  },

  startScreenShare: ({ dispatch, commit, getters, rootGetters }, {layoutType, roomMode, scheduleId}={}) => {
    // if(getters.isScreenShareMode){
    // if(getters.isRoomMode('screenShare')){
    //   dispatch('stopScreenShare')
    //   return;
    // }

    RoomCall.startScreenShare({frameRate: 15}, async stream => {
      if(stream.getVideoTracks().length === 0){
        return;
      }

      stream.getVideoTracks()[0].addEventListener('ended', e => {
        dispatch('stopScreenShare', {roomMode: 'call'})
      });

      if (layoutType) {
        await dispatch('changeMixingLayoutType', { layoutType })
      }
      
      if(roomMode !== false){
        roomMode = roomMode || 'screenShare';
        if(!getters.isRoomMode(roomMode)){
          Room.changeRoomMode(roomMode);
        }

        if(scheduleId) {
          await dispatch('changeScheduleState', {
            scheduleId,
            scheduleState: true
          })
        }
      }
    });
  },
  stopScreenShare: ({ dispatch, commit, getters, rootGetters }, data={}) => {
    let {userId, roomMode} = data;
    
    if(!userId){
      userId = rootGetters['user/getScreenShareUser']?.userId
    }
    RoomCall.stopScreenShare({userId, publish: true});
    if(!roomMode) return;
    Room.changeRoomMode(roomMode);
  },
  toggleShowParticipationRate: async ({ dispatch, commit, getters, rootGetters }) => {
    clearTimeout(data._timer_tsp);
    if(!getters.showParticipationRate){
      await dispatch('user/loadSpeakDataMap', null, {root: true});

      data._timer_tsp = setTimeout(() => {
        commit('TOGGLE_SHOW_PARTICIPATION_RATE', false);
      },5000);
    }
    commit('TOGGLE_SHOW_PARTICIPATION_RATE');
  },

  // 임시
  getScreenShareStream: ({ dispatch, commit, getters, rootGetters }) => {
    let stream = Room.Call.Stream.getCurrentScreenStream();
    if(stream) return stream;

    let mixer = Room.Call.Mixer.getMixer();
    if(!mixer || !mixer.conn || !mixer.conn.getPeerConnection()){
      return null;
    }
    stream = mixer.conn.secondStream || mixer.conn.getPeerConnection().getRemoteStreams()[1];
    return stream;
  },

  startSchedule: async ({ dispatch, commit, getters, rootGetters }, { currentSchedule, nextSchedule }) => {
    const { scheduleType, scheduleId, scheduleState, layoutDivisionCode, learningFileId } = nextSchedule;

    const impossibleControlUser = rootGetters['user/isParticipantRole']() || rootGetters['user/isObserverRole']();
    if (scheduleState || impossibleControlUser) {
      return;
    }

    if (currentSchedule.scheduleType === 'screenShare') {
      await dispatch('stopScreenShare');
    }

    const isNextSchedule = !!nextSchedule
    if (currentSchedule.scheduleType === 'group') {
      await dispatch('group/endRoomGroup', {isNextSchedule}, { root: true });
    }

    let layoutType = ''
    switch (scheduleType) {
      case 'call':
        layoutType = `clone_mode_11_22_0${layoutDivisionCode}`
        break
      case 'group':
        if (getters.isRoomTypeWebinar) {
          return await dispatch('common/setAlert', {
            text: '웨비나 강의에서는 그룹 토의를 진행하실 수 없습니다.',
            onlyOk: true,
          }, { root: true })
        }

        layoutType = 'ml_rg_group_area_film_01_00'
        break
      case 'doc': {
        layoutType = layoutDivisionCode === '0'
          ? `clone_mode_empty_11_22_01`
          : `clone_mode_le_11_22_0${Number(layoutDivisionCode) + 1}`

        if (learningFileId) {
          await dispatch('doc/changeRoomDocPage', {
            docId: learningFileId
          }, { root: true })
        }
        break
      }
      case 'screenShare':
        layoutType = 'screen_share_mode_11_22_01'
        break
      default:
        layoutType = 'clone_mode_le_11_22_07'
        break
    }

    if (
      getters.roomScheduleList
        .filter(sc => sc.scheduleId === scheduleId)
        .some(sc =>
          (sc.scheduleType === 'quiz' || sc.scheduleType === 'debate') &&
          (sc.scheduleState === true || sc.scheduleState === false)
        ) && !getters.room.isTestMode
    ) {
      return await dispatch('common/setAlert', {
        text: `이미 종료된 퀴즈/토론이므로 진행하실 수 없습니다.
        결과를 공유하시겠습니까?`,
        okText: '결과 공유',
        ok: async () => {
          await dispatch('quiz/getQuizByScheduleId', scheduleId, { root: true })
            .then(async data => {
              await dispatch('quiz/onStartQuiz', {
                quizId: data.data.quizId,
                roomMode: scheduleType,
                quizState: 'share',
                scheduleId
              }, { root: true });
            });
        }
      }, { root: true });
    }

    switch (scheduleType) {
      case 'quiz':
      case 'debate':
        try {
          await dispatch('quiz/getQuizByScheduleId', scheduleId, { root: true })
            .then(async data => {
              const quizId = data.data.quizId
              await dispatch('quiz/onStartQuiz', {
                quizId,
                roomMode: scheduleType,
                scheduleId
              }, { root: true });
            })
        } catch (err) {
          console.error(err)
        }

        break
      case 'group':
        var roomGroupList = await dispatch('group/createRoomGroupWithSchedule', nextSchedule, { root: true })
        await dispatch('group/createAndStartRoomGroup', roomGroupList, { root: true })
        await dispatch('changeRoomMode', { roomMode: 'group' })
        await dispatch('changeScheduleState', { scheduleId, scheduleState: true })
        break
      case 'screenShare':
        await dispatch('common/setAlert', {
          title: '화면공유 알림',
          text: '화면공유는 학습목차를 직접 클릭해서 시작해주세요',
          onlyOk: true
        }, { root: true })
        break
      default:
        await dispatch('changeRoomMode', { roomMode: scheduleType })
        await dispatch('changeMixingLayoutType', { layoutType })
        await dispatch('changeScheduleState', { scheduleId, scheduleState: true })
        break
    }

    if (scheduleType === 'call') {
      dispatch('setRoomUserInLayout', { scheduleId });
    }
  },

  changeScheduleState: async ({ dispatch, commit, getters, rootGetters }, { scheduleId, scheduleState }) => {
    await RoomGoalSchedule.changeScheduleState({scheduleId, scheduleState})
  },

  changeReadyToSchedule: ({ dispatch, commit, getters, rootGetters }, { state = true, time }) => {
    commit('CHANGE_READY_TO_SCHEDULE', state);

    if (getters.readyToSchedule) return;

    const timeout = 1000;
    const updateReadyToScheduleTime = () => {
      commit('CHANGE_READY_TO_SCHEDULE_TIME', time / 1000);

      if (getters.readyToSchedule) return;

      time = time - timeout;
      setTimeout(updateReadyToScheduleTime, timeout);
    }

    updateReadyToScheduleTime();
  },

  returnRoomMode: async ({ dispatch, commit, getters, rootGetters }) => {
    dispatch('doc/changeRoomDocPage', rootGetters['doc/firstWhiteBoardRoomDocFile'], { root: true });
    dispatch('changeMixingLayoutType', {});
    await dispatch('changeRoomMode', { roomMode: getters.isRoomTypeWebinar ? 'call' : 'doc' });
  },

  toggleUserMixingVideoByUserId: ({ dispatch, commit, getters, rootGetters }, roomUser) => {
    if (!roomUser.userId) {
      return dispatch('common/setAlert', {
        text: '존재하지 않는 사용자입니다.',
        onlyOk: true,
      }, { root: true });
    }

    const hasUserInChannel = rootGetters['user/hasUserInChannel'](roomUser);
    return RoomCallMixer.toggleUserMixingVideoByUserId({
      userId: roomUser.userId,
      visible: !hasUserInChannel
    });
  },

  setRoomUserInLayout: async ({ dispatch, commit, getters, rootGetters }, params) => {
    const lectureScheduleCallLayoutInfo = await dispatch('getLectureScheduleCallLayoutInfo', params);

    if (!lectureScheduleCallLayoutInfo.length) return;

    for (const layoutInfo of lectureScheduleCallLayoutInfo) {
      RoomCallMixer.changeMixingVideoChannelByUserId({
        userId: layoutInfo.userId,
        channel: getters.oneLineMixerLayoutCount + layoutInfo.channelIndex,
      });
    }
  },

  getLectureScheduleCallLayoutInfo: async ({ dispatch, commit, getters, rootGetters }, params) => {
    return await RoomGoalSchedule.getLectureScheduleCallLayoutInfo(params);
  },
  changeRoomTitle: async ({ dispatch, commit, getters, rootGetters }, roomTitle) => {
    return await Room.changeRoomTitle(roomTitle)
  },
  changeDefinePasswd: async ({ dispatch, commit, getters, rootGetters }, {definePasswd, password}) => {
    return await Room.changeDefinePasswd({definePasswd, password})
  },
}
